import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Tracks SPA route changes in Matomo.
 * The initial pageview is handled by the script loader in index.html.
 * This component fires a new pageview on every subsequent client-side navigation.
 */
export function MatomoTracker() {
  const { pathname, search } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render. The index.html loader already tracks the initial page view
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const _paq = (window as any)._paq;
    if (!_paq) return;

    const url = window.location.origin + pathname + search;
    _paq.push(['setCustomUrl', url]);
    _paq.push(['setDocumentTitle', document.title]);
    _paq.push(['trackPageView']);
  }, [pathname, search]);

  return null;
}
